export default [
	{
		modulo: 32,
		privilegio: 315,
		routerName: 'malha-voos',
		routerPath: '/malha-voos',
		componentName: 'MalhaVoos',
		componentPath: 'modules/layout/gestao-malha/voos/main'
	},
	{
		modulo: 32,
		privilegio: 318,
		routerName: 'malha-calendario-semanal',
		routerPath: '/malha-calendario-semanal',
		componentName: 'MalhaCalendarioSemanal',
		componentPath: 'modules/layout/gestao-malha/calendario-semanal/main'
	},
	{
		modulo: 32,
		privilegio: 321,
		routerName: 'malha-calendario-anual',
		routerPath: '/malha-calendario-anual',
		componentName: 'MalhaCalendarioAnual',
		componentPath: 'modules/layout/gestao-malha/calendario-anual/main'
	},
	{
		modulo: 32,
		privilegio: 324,
		routerName: 'malha-ordens-geradas',
		routerPath: '/malha-ordens-geradas',
		componentName: 'MalhaOrdensGeradas',
		componentPath: 'modules/layout/gestao-malha/ordens-geradas/main'
	},
	{
		modulo: 32,
		privilegio: 327,
		routerName: 'malha-timeline-voo',
		routerPath: '/malha-timeline-voo',
		componentName: 'MalhaTimeline',
		componentPath: 'modules/layout/gestao-malha/timeline-voo/main'
	}
]
